import React from "react";

const SectionListing = ({title, primaryBackground, dataId, loadMoreCta, href, children, hrefLabel = "View more", ...other}) => (
  <section className={`section-listing${primaryBackground ? "" : " section-listing--gray"}`} data-id={dataId} {...other}>
    <div className="shell">
      <header className="section__head">
        <p className="section__title title h2 text-gray">{title}</p>
      </header>
      <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
        <ul>
          {children}
        </ul>
        <div className="swiper-pagination boxes__pagination" />
      </div>
      {loadMoreCta}
      {href ? <a href={href} className="section__btn btn btn--green js-load-more-btn">{hrefLabel}</a> : <></>}
    </div>
  </section>
);

export default SectionListing;